module.exports = __webpack_public_path__ + "static/media/img3.d0e2a769.jpg";